import React from "react";
import { EditorState } from 'draft-js';
import translateString from "../utils/Locales";

import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import './css/editor.css';

let t = translateString;

export default class DetailsDialog extends React.Component {

    constructor(props){
        super(props);

        this.state = {
            editorState: EditorState.createEmpty(),
            subject: '', 
            openDetails: true, 
            openExams: false
        }
    }

    onContentStateChange = contentState => {

        this.savedEnabled = true;
        this.setState({ contentState });
    }

    manageSelection({ selected }) {
        if (selected == 'mainPage') {
            this.setState({ openDetails: true, openExams: false });
        } else if (selected == 'examsPage') {
            this.setState({ openDetails: false, openExams: true });
        }
    }

    render() {

        return ( 
            <div style={{display: this.props.show == true ? 'block' : 'none'}}> 
                <div style={container} onClick={() => this.props.onClose()}>
                    <div style={mainClass} onClick={(e) => e.stopPropagation()}>
                        <div style={closeBtn} onClick={() => {
                            this.props.onClose();
                        }}>
                            <img alt="" src={ require('../images/close_icon.png')} style={{ width: 30, height: 30, cursor: 'pointer' }} />
                        </div>
                        <div style={windowTitle}>{this.props.studentDetails}</div>
                        <div style={{ display: 'flex', marginLeft: 5, marginBottom: 0, marginTop: 0 }}>
                            <img alt="" src={ require('../images/question_icon.png') } style={{ width: 10, height: 10, marginRight: 5, marginTop: 1 }} />
                            <p style={{ fontSize: 10, color: 'darkgray', maxWidth: '80%' }}>{t('studente_details_info')}</p><br/>
                        </div>
                        { (this.props.retired != undefined && this.props.retired) && <div style={subtitle}>{t('studente_ritirato')}</div> }
                        <div style={selectionDiv}>
                            { this.state.openDetails ? (
                                <div style={{...selectionButton, color: '#f58320'}}><b>{this.props.title}</b></div>
                            ) : (
                                <div style={selectionButton} onClick={() => this.manageSelection({ selected: 'mainPage' })}>{this.props.title}</div>
                            )}
                            { this.state.openExams ? (
                                <div style={{...selectionButton, color: '#f58320'}}><b>{t('dettaglio_esami')}</b></div>
                            ) : (
                                <div style={selectionButton} onClick={() => this.manageSelection({ selected: 'examsPage' })}>{t('dettaglio_esami')}</div>
                            )}
                        </div>
                        <div style={{height: '1px', width: '90%', marginTop: '-10px', marginLeft: '5%', backgroundColor: '#BDBDBD'}}></div>
                        <div style={{marginTop: '25px'}}>
                            { this.state.openExams && (
                                this.props.exams.map((exam) => {

                                    console.log(exam);
                                    
                                    return (
                                        <>
                                            <div style={infoDiv}>
                                                <div style={examDescDiv}>{exam[0]}</div>
                                                <div style={examAvgDiv}><b>{exam[1]}</b></div>
                                            </div>
                                            <div style={{height: '1px', width: '80%', marginTop: '8px', marginLeft: '10%', backgroundColor: '#D8D8D8'}}></div>
                                        </>
                                    );
                                })
                            )}
                            { this.state.openDetails && (
                                this.props.details.map((det) => {
                                    return (
                                        <>
                                            <div style={infoDiv}>
                                                <div style={examDescDiv}>{det[0]}</div>
                                                <div style={examAvgDiv}><b>{det[1]}</b></div>
                                            </div>
                                            <div style={{height: '1px', width: '80%', marginTop: '8px', marginLeft: '10%', backgroundColor: '#D8D8D8'}}></div>
                                        </>
                                    );
                                })
                            )}
                        </div>
                    </div>
                </div>
            </div>
        )
    
    }
}

const windowTitle = {
    color: 'darkgrey', 
    fontSize: 30, 
    fontWeight: 'bold', 
    fontFamily: 'Teko', 
    textAlign:'left', 
    marginLeft: 5, 
}

const mainClass = {
    position: 'absolute',
    top: '100px',
    left: '25%', 
    width: '50%',
    height: '540px',
    background: 'white',
    padding: '2%', 
    boxShadow: '0px 2px 10px darkgrey',
    borderRadius: '10px', 
    overflowX: 'hidden', 
    overflowY: 'scroll',
}

const container = {
    position: 'fixed', 
    display: 'block', 
    top: 0,
    left: 0, 
    bottom: 0, 
    right: 0,
    minWidth: '100%', 
    minHeight: '100%', 
    backgroundColor: '#3C3C3C4D',
    overflowX: 'hidden', 
    overflowY: 'scroll',
};

const subtitle = {
    position: 'relative',
    textAlign: 'center',
    width: '100%',
    fontWeight: 'bold', 
    fontSize: '0.7rem', 
    color: 'red'
}

const closeBtn = {
    position: 'absolute',
    right: 10,
    top: 10,
    padding: 10, 
    zIndex: 999, 
    cursor: 'pointer',
}

const selectionDiv = {
    marginLeft: '10%',
    display: 'flex', 
    height: '40px', 
    width: '80%',
    maxWidth: '80%', 
    marginTop: '25px', 
    marginBottom: '20px', 
    cursor: 'pointer'
} 

const selectionButton = {
    flex: 1,
    textAlign: 'center'
}

const infoDiv = {
    marginLeft: '10%',
    display: 'flex', 
    minHeight: '15px', 
    width: '80%',
    maxWidth: '80%',
    marginTop: '5px'
}

const examDescDiv = {
    flex: 1, 
    textAlign: 'start', 
    width: '100%'
}

const examAvgDiv = {
    flex: 1, 
    textAlign: 'end', 
    alignContent: 'flex-end', 
    alignItems: 'center',
    width: '100%'
}